export enum ActionType {
  FETCH_ACCESS_TOKEN_REQUEST = "FETCH_ACCESS_TOKEN_REQUEST",
  FETCH_ACCESS_TOKEN_SUCCESS = "FETCH_ALERTS_SUCCESS",
  FETCH_ACCESS_TOKEN_FAILURE = "FETCH_ALERTS_FAILURE",

  FETCH_ISSUER_REQUEST = "FETCH_ISSUER_REQUEST",
  FETCH_ISSUER_SUCCESS = "FETCH_ISSUER_SUCCESS",
  FETCH_ISSUER_FAILURE = "FETCH_ISSUER_FAILURE",

  FETCH_AUTH_USER_INFO_REQUEST = "FETCH_AUTH_USER_INFO_REQUEST",
  FETCH_AUTH_USER_INFO_SUCCESS = "FETCH_AUTH_USER_INFO_SUCCESS",
  FETCH_AUTH_USER_INFO_FAILURE = "FETCH_AUTH_USER_INFO_FAILURE",

  FETCH_USER_INFO_REQUEST = "FETCH_USER_INFO_REQUEST",
  FETCH_USER_INFO_SUCCESS = "FETCH_USER_INFO_SUCCESS",
  FETCH_USER_INFO_FAILURE = "FETCH_USER_INFO_FAILURE",
}

export interface IAction {
	type: ActionType;
	payload?: any;
}